(function ($) {
  var isOpen = 'is-open';

  function killMenu() {
    $('.menu-toggler').removeClass('menu-toggler--nav-open');
    $('.menu').removeClass(isOpen);
    $('.backdrop').remove();
    $('body').removeClass('nav-open');
    $('.menu__item--has-children').removeClass(isOpen);
  }

  $(document).on('click', '.hamburger', function () {
    $('body').toggleClass('nav-open');
    $('.header__bottom').slideToggle();
  });

  $(document).on('click', '.menu-toggler', function () {
    $('body').addClass('nav-open');

    if (!$('.backdrop').length) {
      $('body').append('<div class="backdrop"></div>');
    }
  });

  $(document).on('click', '.backdrop', function () {
    killMenu();
  });

  $(document).on('keyup', function (e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
      killMenu();
    }
  });

  $(document).on('click', '.menu-toggler', function () {
    var target = $(this).attr('data-target');
    var button = '.menu-toggler[data-target="' + target + '"]';

    $('#' + target).toggleClass(isOpen);
    $('.menu').not('#' + target).removeClass(isOpen);
    $(button).toggleClass('menu-toggler--nav-open');
    $('.menu-toggler').not($(button)).removeClass('menu-toggler--nav-open');
  });

  $(document).on('click', '.menu__item--has-children', function () {
    $(this).toggleClass(isOpen);
    $('.menu__item--has-children').not($(this)).removeClass(isOpen);

  });
})(jQuery);
